import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
import { InputStylingModel } from '../input/input-styling.model';
export class DatatableFilterStylingModel extends CoreStylingModel {
/**
 * Styling of inputFilter by InputStylingModel
 */
inputStyling?: InputStylingModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function DatatableFilterStylingModel_tsickle_Closure_declarations() {
/**
 * Styling of inputFilter by InputStylingModel
 * @type {?}
 */
DatatableFilterStylingModel.prototype.inputStyling;
}

